import { useMutation } from '@tanstack/react-query';
import { POST, POST_TRANSFER_VERIFY } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';

export const useTransferVerify = () => {
  return useMutation({
    mutationFn: async ({ oldTelephone, newTelephone }) => {
      try {
        const payload = {
          oldTelephone,
          newTelephone,
        };
        const response = await POST(POST_TRANSFER_VERIFY(), payload);
        return response;
      } catch (error) {
        throw { ...error, disabledThrow: true };
      }
    },
    onSuccess: (data) => {
      openAlert({
        model: 'message',
        type: 'success',
        message: data?.message,
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
    },
  });
};
